<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-body v-if="reservation">
        <b-row>
          <b-col lg="4">
            <p><strong>Comments:</strong></p>
            <p>
              {{ reservation.comments }}
            </p>
          </b-col>
          <b-col lg="8">
            <p><strong>Prefered Accommodation:</strong></p>
            <b-list-group>
              <b-list-group-item>Accomodation Type: {{ reservation.accomodation_type }}</b-list-group-item>
              <b-list-group-item>Toilet Type: {{ reservation.toilet_type }}</b-list-group-item>
              <b-list-group-item>AC Room: {{ reservation.ac_room }}</b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-body>
        <strong>Selected rooms</strong>
        <b-row>
          <b-col lg="12">
            <room-selected :reservation="reservation" @deleted="deleteRoom" ref="roomSelected"></room-selected>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-body>
        <b-button-toolbar class="pull-right">
          <b-btn variant="primary" @click="paymentReceived" class="mr-1"
            :disabled="selectedRooms.length == 0">Reserve Rooms</b-btn>
        </b-button-toolbar>
      </b-card-body>
    </b-card>

    <b-card no-body>
      <b-card-body>
        <strong>Available rooms</strong>
        <building-search :reservation="reservation" @selected="addRoom" ref="buildingSearch"></building-search>
      </b-card-body>
    </b-card>



  </div>
</template>

<script>
import RoomSelected from './RoomSelected'
import BuildingSearch from './BuildingSearch'
import {
  mapState,
} from 'vuex'
import moment from 'moment'
export default {
  name: "SingleManualMatching",
  props: {
    reservation: Object,    
  },
  components: {
    RoomSelected,
    BuildingSearch,
  },
  computed: mapState({
    buildings: state => state.reservations.availableBuildings,
    availRooms: state => state.reservations.availableRooms,
    selectedRooms: state => state.reservations.selectedRooms
  }),
  data() {
    return {
      reservationStatus: ""
    }
  },
  methods: {
    addRoom(room) {
      this.$refs.roomSelected.addRoom(room)
    },
    deleteRoom(room) {
      this.$refs.buildingSearch.deselectRoom(room)
    },
    paymentSuccess() {
      this.$emit('change')
    },
    stayDays() {
      let start = moment(this.reservation.arrival_date);
      let end = moment(this.reservation.departure_date);
      let duration = moment.duration(end.diff(start));
      let days = duration.asDays();
      return Math.round(days);
    },
    totalAmount() {
      let total = 0;
      let totalDays = this.stayDays();
      console.log(totalDays);
      _.each(this.selectedRooms, (room) => {
        total += parseFloat(room.price * totalDays)
      })
      // total = _.round(total, 2).toFixed(2)
      console.log(total);
      return total
    },
    paymentReceived() {
      let selectedIds = _.map(this.selectedRooms, room => room.id)
      let params = {
        id: this.reservation.id,
        payment_amount: this.totalAmount(),
        donation_amount: 0,
        payment_type: 'CASH',
        room_ids: selectedIds,
        oldStatus: this.reservationStatus
      }
      this.$store.dispatch('reservations/setStatusHoldAutoPayment', params)
        .then(() => {        
            this.$emit('change')
            this.showSuccessMsg()          
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else {
            this.showErrorMsg()
          }
        })
    },
    holdForPayment(isPayment) {
      let selectedIds = _.map(this.selectedRooms, room => room.id)
      this.$store.dispatch('reservations/setStatusHold', { id: this.reservation.id, status: 'HOLD', room_ids: selectedIds })
        .then(() => {
          if (isPayment) {
            this.$emit('payment', this.reservation)
          } else {
            this.$emit('change')
            this.showSuccessMsg()
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else {
            this.showErrorMsg()
          }
        })      
    }
  },
  created() {
    this.$store.dispatch('reservations/getSelectedRooms', { id: this.reservation.id })
    console.log(this.reservation);
    if(this.reservation['building'] != null && this.reservation['building']['id'] != null){
      this.$store.dispatch('reservations/searchAvailableRooms', { arrival: this.reservation.arrival_date, departure: this.reservation.departure_date, building_id: this.reservation.building.id })

    }
    else{
      this.$store.dispatch('reservations/searchAvailableRooms', { arrival: this.reservation.arrival_date, departure: this.reservation.departure_date })

    }
  
    this.reservationStatus = this.reservation != null && this.reservation.status != null ? this.reservation.status  : "";
  }
}
</script>
